export default __webpack_public_path__ + "static/media/rune.b667b84a.png";